import React, { FC } from 'react';

import { Container, Text } from '@lglp/components';
import { SocialNetwork } from '@lglp/prismic-client';
import { useTranslation } from 'react-i18next';

import { FOOTER } from 'translations';

import styles from './FooterSocial.module.scss';
import { SocialLink } from './SocialLink';

export const FooterSocial: FC<FooterSocialProps> = ({
  socialLinks,
  className,
}) => {
  const { t } = useTranslation();
  return (
    <Container as="section" className={[styles.footerSocial, className]}>
      <Text
        className={styles.footerSocialTitle}
        body={t(FOOTER.SOCIAL_TITLE)}
      />
      <Container className={styles.footerSocialWrapper}>
        {socialLinks?.map(({ type, link }, idx) => (
          <SocialLink key={idx} type={type} link={link} />
        ))}
      </Container>
    </Container>
  );
};

export type FooterSocialProps = {
  socialLinks: SocialNetwork[];
  className?: string;
};
